import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApproveDialogResults } from '../../enums/approve-dialog-results.enum';

@Component({
  selector: 'app-approve-payform',
  templateUrl: './approve-payform.component.html',
  styleUrls: ['./approve-payform.component.scss'],
})
export class ApprovePayformComponent implements OnInit {
  public ApproveDialogResults = ApproveDialogResults;

  constructor(private dialogRef: MatDialogRef<ApprovePayformComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}

  closeDialog(buttonLabel: ApproveDialogResults) {
    this.dialogRef.close(buttonLabel);
  }
}
